import { render } from "./Jornadas.vue?vue&type=template&id=0f74ae06"
import script from "./Jornadas.vue?vue&type=script&lang=js"
export * from "./Jornadas.vue?vue&type=script&lang=js"

import "./Jornadas.vue?vue&type=style&index=0&id=0f74ae06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__